import React from 'react';
import PropTypes from 'prop-types';

const RELOAD_FLAG = 'chunkErrorReload';

function isChunkLoadError(error) {
  return error?.name === 'ChunkLoadError' || /Loading (chunk|CSS chunk) \d+ failed/.test(error?.message || '');
}

export default class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidMount() {
    // Chegou até aqui sem erro: limpa a marca de reload de uma tentativa anterior.
    sessionStorage.removeItem(RELOAD_FLAG);
  }

  componentDidCatch(error) {
    if (!isChunkLoadError(error)) return;

    // Um deploy novo trocou o hash dos chunks; a aba com o build antigo não
    // encontra mais o arquivo. Recarrega uma única vez para pegar o build atual.
    if (!sessionStorage.getItem(RELOAD_FLAG)) {
      sessionStorage.setItem(RELOAD_FLAG, '1');
      window.location.reload();
    }
  }

  render() {
    const { hasError, error } = this.state;
    const { children } = this.props;

    if (hasError) {
      if (!isChunkLoadError(error)) throw error;
      return <div>Carregando...</div>;
    }

    return children;
  }
}

ChunkErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};
